import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

import { isImageGenerationTool } from 'src/data/generationTool';
import { addLanguageToGenerationResults } from 'src/data/variation';
import { rephraseTextsForDocumentEditor } from 'src/graphql/generation';

import { getGenerationLoaderContent } from '../../utils';

const INITIAL_STATE = {
  generating: false,
  generatingLoaderText: null,
  lastGenerationResult: null,
};

export const PRIVATE_ACTIONS = {
  init:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },

  generateGeneratingLoaderText:
    (params) =>
    ({ setState }) => {
      const loaderContent = getGenerationLoaderContent(params);
      setState({ generatingLoaderText: loaderContent });
    },

  clearGeneratingLoaderText:
    () =>
    ({ setState }) => {
      setState({ generatingLoaderText: null });
    },

  generate:
    ({ generator, inputParams, hideLoader }) =>
    async ({ setState, dispatch }, { project }) => {
      if (!hideLoader) {
        setState({ generating: true });
      }

      try {
        const params = {
          ...inputParams,
          projectId: project.id,
        };

        // Generate and store text that will be shown on the floating "loader" panel
        dispatch(PRIVATE_ACTIONS.generateGeneratingLoaderText(params));

        const results = await generator(params, {
          async: isImageGenerationTool(params.generationTool),
        });
        return addLanguageToGenerationResults(results);
      } finally {
        setState({ generating: false });
        dispatch(PRIVATE_ACTIONS.clearGeneratingLoaderText());
      }
    },
};

const ACTIONS = {
  generateRecompose:
    (inputParams, hideLoader) =>
    ({ dispatch }) => {
      return dispatch(
        PRIVATE_ACTIONS.generate({
          generator: rephraseTextsForDocumentEditor,
          inputParams,
          hideLoader,
        })
      );
    },

  setLastGenerationResult:
    (value) =>
    ({ setState }) => {
      setState({ lastGenerationResult: value });
    },

  setGenerating:
    (value) =>
    ({ setState }) => {
      setState({ generating: value });
    },

  removeVariationFromLastGenerationResult:
    (variationId) =>
    ({ getState, setState }) => {
      const { lastGenerationResult: result } = getState();
      if (!result) {
        return;
      }

      // Remove variation from the "result"
      const newVariations = result.variations.filter((v) => v.id !== variationId);

      // Replace "last generated result" object
      setState({
        lastGenerationResult: {
          ...result,
          variations: newVariations,
        },
      });
    },
};

export const GenerationStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'document-view-generation',
});
